<script setup lang="ts">
defineProps<{
  campaign: Campaign | null | undefined
}>()
</script>

<template>
  <UArticleContainer
    v-if="campaign?.show"
    as="section"
    class="flex flex-col items-center gap-legacy-l rounded-md bg-yellow-pop px-legacy-xl py-legacy-m text-center leading-6 text-green-50 sm:flex-row sm:text-start"
  >
    <IconsDiscount
      :value="campaign.offerPercentage"
      class="[--background:white] [--color:var(--color-coral-pop)] [--stroke:none]"
    />
    <div>
      <h4
        v-if="campaign.title"
        class="font-headline text-2xl leading-8 font-semibold"
        v-text="campaign.title"
      />
      <div v-if="campaign.description" v-html="campaign.description" />
    </div>
  </UArticleContainer>
</template>
